import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetCrmCalendar } from 'services/CRMService'



export const getEvents = createAsyncThunk(
    'crmCalendar/data/getEvents',
    async (data) => {
        const response = await apiGetCrmCalendar(data)
        return response
    },
)

const initialState = {
    loading: false,
    eventList: [],
    dialogOpen: false,
    selected: {
        type: '',
    },
}

const calendarSlice = createSlice({
    name: `crmCalendar/data`,
    initialState,
    reducers: {
        updateEvent: (state, action) => {
            state.eventList = action.payload
        },
        openDialog: (state) => {
            state.dialogOpen = true
        },
        closeDialog: (state) => {
            state.dialogOpen = false
        },
        setSelected: (state, action) => {
            state.selected = action.payload
        },
    },
        extraReducers: {
            [getEvents.fulfilled]: (state, action) => {
                state.eventList = action.payload.data
                state.loading = false
            },
            [getEvents.pending]: (state) => {
                state.loading = true
            },
        },
})

export const { updateEvent, openDialog, closeDialog, setSelected } =
    calendarSlice.actions

export default calendarSlice.reducer
